import taskMixin from '../../../mixins/taskMixin'
import Navigation from '../../navigation/Navigation.vue'

export default {
    name: 'DrivingServiceCheckin',

    mixins: [taskMixin],

    components: {
        Navigation
    },

    data() {
        return {
            taskTitle: 'Fahrdienst Checkin'
        }
    }
}
